import { API_AUTH, setTokenGlobal } from "../common";
import { withCookies, Cookies } from "react-cookie";
import { getDomain } from "utils/utils";

var urlNew = getDomain();
const cookies = new Cookies();
var token = cookies.get("userTokenDaiLy");
if (typeof token != "undefined" && token.length > 6) {
  token = token.substring(6);
  setTokenGlobal(token, urlNew);
}
export default {
  getCauHinhJs: (params) => API_AUTH.get("hethongnt/cauhinhjs", params),
  getLichSuView: (params) =>
    API_AUTH.get("lichsuview/loadMenuThuongDung", params),
  saveLichSuView: (params) =>
    API_AUTH.post("lichsuview/saveLichSuView", params),
  SaveStKey: (KeyID, Value) =>
    API_AUTH.post(`hethongnt/SaveStKey?KeyId=${KeyID}&Value=${Value}`, {}),
  getDTimeSys: () => {
    return API_AUTH.get(`hethongnt/getDTimeSys`, {});
  },
};
